import { useEffect, useState } from 'react';

/**
 * Debounces a value
 * @param value - value to debounce
 * @param delay - delay in milliseconds (500ms by default)
 * @returns debounced value
 */
export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
